/**
 * 游戏配置
 */
import Url from 'c-url';

var config = {
    // 繁体版本
    'TW': [{
        key: 'gamehall',
        name: '游戏大厅',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?td_channelid=h5uplive&from=100',
        images: require('../../images/gamecenter/tw/gamehall.jpg')
    }, {
        key: 'luckyfruit',
        name: '幸运水果机',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=12&td_channelid=h5uplive&from=100',
        images: require('../../images/gamecenter/tw/luckyfruit.jpg')
    }, {
        key: 'horserace',
        name: '极速赛马场',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=20&td_channelid=h5uplive&from=100',
        images: require('../../images/gamecenter/tw/horserace.jpg')
    }, {
        key: 'speedduel',
        name: '豪车派对',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=23&td_channelid=h5uplive&from=100',
        images: require('../../images/gamecenter/tw/speedduel.jpg')
    }, {
        key: 'phoenixwar',
        name: '凤凰烈焰',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=32&td_channelid=h5uplive&from=100',
        images: require('../../images/gamecenter/tw/phoenixwar.jpg')
    }, {
        key: 'forsetparty',
        name: '鸿运转转赚',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=36&td_channelid=h5uplive&from=100',
        images: require('../../images/gamecenter/tw/forsetparty.jpg')
    }, {
        key: 'bountyhunte',
        name: '赏金猎人',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=40&td_channelid=h5uplive&from=100',
        images: require('../../images/gamecenter/tw/bountyhunter.jpg')
    }, {
        key: 'roulette',
        name: '欢乐轮盘',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=38&td_channelid=h5uplive&from=100',
        images: require('../../images/gamecenter/tw/roulette.jpg')
    }, {
        key: 'dragonboat',
        name: '龙舟大赛',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=39&td_channelid=h5uplive&from=100',
        images: require('../../images/gamecenter/tw/dragonboat.jpg')
    }],
    // 英文
    'EN': [{
        key: 'gamehall',
        name: '游戏大厅',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/en/gamehall.jpg')
    }, {
        key: 'luckyfruit',
        name: '幸运水果机',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=12&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/en/luckyfruit.jpg')
    }, {
        key: 'horserace',
        name: '极速赛马场',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=20&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/en/horserace.jpg')
    }, {
        key: 'speedduel',
        name: '豪车派对',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=23&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/en/speedduel.jpg')
    }, {
        key: 'phoenixwar',
        name: '凤凰烈焰',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=32&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/en/phoenixwar.jpg')
    }, {
        key: 'bountyhunte',
        name: '赏金猎人',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=40&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/en/bountyhunter.jpg')
    }, {
        key: 'roulette',
        name: '欢乐轮盘',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=38&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/en/roulette.jpg')
    }],
    // 阿语
    'EG': [{
        key: 'luckyfruit',
        name: '幸运水果机',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=12&td_channelid=h5uplive&region=3&from=100',
        images: require('../../images/gamecenter/eg/luckyfruit.jpg')
    }, {
        key: 'horserace',
        name: '极速赛马场',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=20&td_channelid=h5uplive&region=3&from=100',
        images: require('../../images/gamecenter/eg/horserace.jpg')
    }, {
        key: 'phoenixwar',
        name: '凤凰烈焰',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=32&td_channelid=h5uplive&region=3&from=100',
        images: require('../../images/gamecenter/eg/phoenixwar.jpg')
    }, {
        key: 'forsetparty',
        name: '鸿运转转赚',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=36&td_channelid=h5uplive&region=3&from=100',
        images: require('../../images/gamecenter/eg/forsetparty.jpg')
    }],
    // 印度
    'IN': [{
        key: 'gamehall',
        name: '游戏大厅',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?td_channelid=h5uplive&region=6&from=100',
        images: require('../../images/gamecenter/en/gamehall.jpg')
    }, {
        key: 'luckyfruit',
        name: '幸运水果机',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=12&td_channelid=h5uplive&region=6&from=100',
        images: require('../../images/gamecenter/en/luckyfruit.jpg')
    }, {
        key: 'horserace',
        name: '极速赛马场',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=20&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/en/horserace.jpg')
    }, {
        key: 'phoenixwar',
        name: '凤凰烈焰',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=32&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/en/phoenixwar.jpg')
    }, 
    // {
    //     key: 'forsetparty',
    //     name: '鸿运转转赚',
    //     jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=36&td_channelid=h5uplive&region=5&from=100',
    //     images: require('../../images/gamecenter/en/forsetparty.jpg')
    // }
    ],
    // 越南
    'VN': [{
        key: 'gamehall',
        name: '游戏大厅',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/vn/gamehall.jpg')
    }, {
        key: 'luckyfruit',
        name: '幸运水果机',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=12&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/vn/luckyfruit.jpg')
    }, {
        key: 'horserace',
        name: '极速赛马场',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=20&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/vn/horserace.jpg')
    }, 
    // {
    //     key: 'forsetparty',
    //     name: '鸿运转转赚',
    //     jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=36&td_channelid=h5uplive&region=5&from=100',
    //     images: require('../../images/gamecenter/vn/forsetparty.jpg')
    // }, 
    {
        key: 'roulette',
        name: '欢乐轮盘',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=38&td_channelid=h5uplive&region=5&from=100',
        images: require('../../images/gamecenter/vn/roulette.jpg')
    }],
}

var countryConfig = [{
    code: 'TW',
    open: true,
    countryCode: ['CN', 'TW', 'HK', 'SG', 'MY', 'MO','MYC','MYNC'],
}, {
    code: 'EN',
    open: true,
    countryCode: ["GB", "AS", "AT", "AU", "AX", "BB", "BM", "BS", "CZ", "DE", "DK", "FI", "GL", "GR", "GY", "IE", "IS", "IT", "MM", "PL", "PM", "ZR"],
}, {
    code: 'VN',
    open: true,
    countryCode: ['VN'],
}, {
    code: 'IN',
    open: true,
    countryCode: ['IN'],
}, {
    code: 'EG',
    open: true,
    countryCode: ['EG', 'SA', 'MA', 'AE', 'AF', 'BH', 'DJ', 'DZ', 'IQ', 'JO', 'KM', 'KW', 'LB', 'LY', 'MR', 'OM', 'PS', 'QA', 'SD', 'SO', 'SS', 'SSD', 'SY', 'TN', 'YE']
}];

export default {
    getGameConfig(countryCode) {
        let result = [];

        for (let i = 0, len = countryConfig.length; i < len; i++) {
            let item = countryConfig[i];

            if (item.countryCode.indexOf(countryCode) > -1 && item.open) {

                result = config[item.code];
                break;
            }
        }

        return result;
    },

    checkCountryCode(countryCode) {
        let flag = false;

        for (let i = 0, len = countryConfig.length; i < len; i++) {
            let item = countryConfig[i];

            if (item.countryCode.indexOf(countryCode) > -1 && item.open) {

                flag = true;
                break;
            }
        }

        return flag;
    }
};


// WEBPACK FOOTER //
// ./js/gamecenter/config.js